module.exports = __webpack_public_path__ + "operace-usnich-boltcu_6_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-usnich-boltcu_6_before_tn.jpg
// module id = 1690
// module chunks = 0